import Wrapper from "@/components/global/wrapper";
import Analysis from "@/components/marketing/analysis";
import Companies from "@/components/marketing/companies";
import CTA from "@/components/marketing/cta";
import Features from "@/components/marketing/features";
import Hero from "@/components/marketing/hero";
import Integration from "@/components/marketing/integration";

const HomePage = () => {
  return (
    <Wrapper className="py-20 relative" data-oid="3vd.v7k">
      <Hero data-oid="vcqts7t" />
      <Companies data-oid="48t2b.e" />
      <Features data-oid="-i:8hgo" />
      <Analysis data-oid="06bh30f" />
      <Integration data-oid="3ycngwi" />
      <CTA data-oid="6yrkvj:" />
    </Wrapper>
  );
};

export default HomePage;
